import gql from 'graphql-tag';

import { getSingleProp, prepareACDebugContext } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';

const MUTATION = gql`
  mutation SuggestBlogPostBuilderSection(
    $projectId: ID!
    $sectionId: ID!
    $assetType: AssetTypeEnum!
    $recomposeMode: RecomposeModeEnum
    $continueMode: ContinueModeEnum
    $generationLength: String!
    $keywords: [String!]
    $instruction: Instruction
    $markedSegment: MarkedSegment
    $debugAcPrompt: String
  ) {
    suggestBlogPostBuilderSection(
      projectId: $projectId
      sectionId: $sectionId
      assetType: $assetType
      recomposeMode: $recomposeMode
      continueMode: $continueMode
      generationLength: $generationLength
      keywords: $keywords
      instruction: $instruction
      markedSegment: $markedSegment
      debugAcPrompt: $debugAcPrompt
    ) {
      copyText
      keywordsUsage
    }
  }
`;

export const suggestBlogPostBuilderSection = async (
  {
    projectId,
    sectionId,
    assetType,
    recomposeMode,
    continueMode,
    generationLength,
    keywords,
    instruction,
    markedSegment,
    debugAcPrompt,
  },
  options = null
) => {
  const variables = {
    projectId,
    sectionId,
    assetType,
    recomposeMode,
    continueMode,
    generationLength,
    keywords,
    instruction,
    markedSegment,
    debugAcPrompt,
  };

  const mutateOptions = {
    mutation: MUTATION,
    variables,
    context: prepareACDebugContext('suggest blog builder section', variables),
  };

  if (options?.abortSignal) {
    mutateOptions.context = {
      ...mutateOptions.context,
      fetchOptions: {
        signal: options.abortSignal,
      },
    };
  }

  const response = await apolloClient.mutate(mutateOptions);
  const parsedRes = getSingleProp(response.data);
  return {
    ...parsedRes,
    keywordsUsage: parsedRes.keywordsUsage ? JSON.parse(parsedRes.keywordsUsage) : null,
  };
};
